import { Chip } from "@mui/material";
import ToolTip from "../../../ToolTip/ToolTip";

export const Batch_Assigned_Tutor = [
  {
    field: "subject_enrollment_id",
    minWidth: 100,
    headerName: "Subject ID",
  },
  {
    field: "subject_name",
    minWidth: 200,
    headerName: "Subject Name",
  },
  {
    field: "trainer_name",
    minWidth: 250,
    headerName: "Tutor Name",
    renderCell: (params) => {
      if (params.row.trainer_name === null) {
        return (
          <Chip
            color="error"
            label="Not Assigned"
            size="small"
            variant="outlined"
          />
        );
      } else {
        return (
          <ToolTip
            content={params.row.trainer_name}
            expand={params.row.trainer_name}
          />
        );
      }
    },
  },
  {
    field: "trainer_alphanum_id",
    minWidth: 200,
    headerName: "Trainer ID",
    renderCell: (params) => {
      if (params.row.trainer_alphanum_id === null) {
        return (
          <Chip
            color="warning"
            label="No Data"
            size="small"
            variant="outlined"
          />
        );
      } else {
        return params.row.trainer_alphanum_id;
      }
    },
  },
  {
    field: "session_duration",
    minWidth: 150,
    headerName: "Session Duration",
    renderCell: (params) => {
      if (params.row.session_duration === null) {
        return "N/A";
      } else {
        return params.row.session_duration;
      }
    },
  },
  {
    field: "trainer_payment_per_session",
    minWidth: 150,
    headerName: "TP",
    renderCell: (params) => {
      if (params.row.trainer_payment_per_session === null) {
        return "N/A";
      } else {
        return params.row.trainer_payment_per_session;
      }
    },
  },
  {
    field: "mapping_status",
    minWidth: 200,
    headerName: "Mapping Status",
    renderCell: (params) => {
      if (params.row.mapping_status === 0) {
        return (
          <Chip
            color="error"
            label="Inactive"
            size="small"
            variant="outlined"
          />
        );
      } else if (params.row.mapping_status === 1) {
        return (
          <Chip
            color="primary"
            label="Active"
            size="small"
            variant="outlined"
          />
        );
      } else if (params.row.mapping_status === 2) {
        return (
          <Chip
            color="warning"
            label="Temporary Inactive"
            size="small"
            variant="outlined"
          />
        );
      } else {
        return (
          <Chip
            color="warning"
            label="Not Assigned"
            size="small"
            variant="outlined"
          />
        );
      }
    },
  },
];
